<template>
  <div class="relative text_align_center full_width">
    <p class="absolute center_horizontal" style="top: -40px;">{{ value }}</p>
    <input v-model="value" type="range" :min="minValue" :max="maxValue" @change="$emit('change', $event.target.value)">
  </div>
</template>
<script>
export default {
  name: 'range-bar',
  props: {
    default_value: {
      type: String,
      default: '0'
    },
    minValue: {
      type: String,
      default: '0'
    },
    maxValue: {
      type: String,
      default: '100'
    }
  },
  data () {
    return {
      value: this.default_value
    }
  }
}
</script>
